//PJQRegistration-Master
let regSettings = null, unionPicker = null, minorityPicker = null, coreFieldSettings = null;
PJQ.app.attachReadyEvent(function () {
	PanteraScript.PanteraScriptService.GetRegistrationSettings(pjqSessionId, pjqMasterUserId, pjqContactId, function (response) {
		regSettings = jQuery.parseJSON(response);

		let fnCb = function () {
			PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PJQREGISTRATION, 'Master', {isOldModule: true}), jQuery("#pjq-main"), {
				checkFieldRequired: checkFieldRequired,
				checkFieldVisible: checkFieldVisible
			}, function () {
				GetRegistrationSettingsC();
			});
		};
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS)) {
			PJQ.app.session.fetchContactFieldSettings(PJQ.app.session.get('masterUserId'), _.bind(function (settings) {
				coreFieldSettings = settings;
				fnCb();
			}, this));
		}
		else {
			coreFieldSettings = null;
			fnCb();
		}
	}, onScriptError);
});

function GetRegistrationSettingsC() {
	regSettings.AllStatesStr = 'AK,AL,AR,AS,AZ,CA,CO,CT,DE,DC,FL,GA,GU,HI,ID,IL,IN,IA,KS,KY,LA,MA,MD,ME,MH,MI,MN,MO,MP,MS,MT,NC,ND,NE,NH,NJ,NM,NV,NY,OH,OK,OR,PA,PR,PW,RI,SC,SD,TN,TX,UT,VT,VA,VI,WA,WI,WV,WY';
	regSettings.AllStatesArr = regSettings.AllStatesStr.split(',');
	regSettings.AllProvinceStr = 'AB,BC,MB,NB,NL,NS,NT,NU,ON,PE,QC,SK,YT';
	regSettings.AllProvinceArray = regSettings.AllProvinceStr.split(',');

	if (regSettings.FacebookAPIKey.length > 0 && typeof FB === 'object')
		InitFacebookAPI(regSettings.FacebookAPIKeyregisterSubmitButton);
	else {
		jQuery('.facebookCol').hide();
		jQuery('.loginCol').css('width', '100%');
	}

	if (regSettings.RegistrationHeader.length > 0)
		jQuery('#loginInfoHeader').html(regSettings.RegistrationHeader);

	regSettings.CurrentMode = pjqMode;

	jQuery('#loginFacebookButton, #registerFacebookButton').button({
		icons: {
			primary: "ui-icon-facebook"
		}
	}).on('click', function () {
		CheckLoginState();
	});

	if (pjqMode == 'login') {
		InitLogin();
		jQuery('.loginContainer').show();
		jQuery(window).scrollTop(0);
	}
	else if (pjqMode == 'register') {
		InitRegistration();
		jQuery('.registerContainer').show();
		jQuery(window).scrollTop(0);
	}

	jQuery(window).on('keydown', function (e) {
		if (e.which == 13) {
			if (jQuery(':focus').attr('id') == 'username' || jQuery(':focus').attr('id') == 'password') {
				LoginUser();
			}
		}
	})
}

function LoginTransition() {
	jQuery('.loginContainer').slideDown();
	jQuery('.registerContainer').slideUp();
	InitLogin();
}

function InitLogin() {
	regSettings.CurrentMode = 'login';
	if (regSettings.IsLoginInit)
		return;
	regSettings.IsLoginInit = true;

	jQuery('#loginButton').button().on('click', function () {
		LoginUser();
	});
	jQuery('#registerButton').button().on('click', function () {
		RegistrationTransition();
	});

	if (!regSettings.IsPrivatePlanroom && regSettings.Username.length > 0 && window.location.href.toLowerCase().indexOf('userreg') != -1) {
		jQuery('#username').val(regSettings.Username).prop('disabled', true);
	}
}

function LoginUser() {
	//CreateOverlay('login');
	if (pjqProjectId > 0)
		PanteraScript.PanteraScriptService.UserLoginWithProject(pjqSessionId, jQuery('#username').val(), jQuery('#password').val(), '', pjqContactId, pjqProjectId, LoginUserC, onScriptError);
	else
		PanteraScript.PanteraScriptService.PanteraUserLogin(pjqSessionId, jQuery('#username').val(), jQuery('#password').val(), LoginUserC, onScriptError);
}

function LoginUserC(response) {
	var loginResult = jQuery.parseJSON(response);
	if (loginResult.result == 0) {
		window.location.href = loginResult.redirectURL;
	}
	else {
		DestroyOverlay();
		jQuery('#loginButton').button('enable');
		var resultNote = "";
		if (loginResult.result == 1) {
			resultNote = "Incorrect password";
		}
		else if (loginResult.result == 2) {
			resultNote = "Incorrect username";
		}
		jQuery('#loginError').text(resultNote);
	}
}

function ForgotPasswordDialog() {
	jQuery('#forgotPasswordDialog').dialog({
		title: "Forgot Password",
		modal: true,
		resizable: false,
		dialogClass: 'forgotPasswordDialog',
		width: 400,
		create: function () {
			regSettings.SendCount = 0;
			jQuery('#forgotPasswordButton').button().on('click', function () {
				if (jQuery('#forgotPasswordInput').val().length > 0) {
					RequestPassword();
					jQuery('#sendPasswordError').empty();
				}
				else
					jQuery('#sendPasswordError').text('Please enter a username or email');
			});
			jQuery('#forgotPasswordButtonRepeat').button().on('click', function () {
				RequestPassword();
			});
			if (!regSettings.IsPrivatePlanroom && regSettings.Username.length > 0 && window.location.href.toLowerCase().indexOf('userreg') != -1) {
				jQuery('#forgotPasswordInput').val(regSettings.Username).prop('disabled', true);
			}
		},
		close: function () {
			jQuery('#sendPasswordError').empty();
			regSettings.rpuid = null;
		}
	});
}

function RequestPassword() {
	PanteraScript.PanteraScriptService.RequestPassword(pjqSessionId, jQuery('#forgotPasswordInput').val(), pjqMasterUserId, CheckForgotPasswordUserC, onScriptError);
}

function CheckForgotPasswordUserC(response) {
	var userId = parseInt(response);
	if (userId > 0) {
		jQuery('#forgotPasswordRequestContainer').hide();
		jQuery('#forgotPasswordSuccessContainer').show();
	}
	else {
		regSettings.rpuid = null;
		jQuery('#sendPasswordError').text('No user was found matching the entered email/username');
	}
}

//Registration
function RegistrationTransition() {
	jQuery('#registerBack').show();
	jQuery('.loginContainer').slideUp();
	jQuery('.registerContainer').slideDown();
	if (!regSettings.IsRegisterInit)
		InitRegistration();
	else {
		if (window.regionsMapObj) {
			window.regionsMapObj.refresh();
		}
	}
}

function InitRegistration() {
	regSettings.CurrentMode = 'register';
	if (regSettings.IsRegisterInit)
		return;
	regSettings.IsRegisterInit = true;

	CreateRegistrationCustomFields(regSettings.ContactCustomFields, 'contact');
	CreateRegistrationCustomFields(regSettings.ContactCompanyCustomFields, 'company');

	jQuery('#contactUsername').attr('tabindex', currentTabIndex);
	currentTabIndex++;
	jQuery('#contactPassword').attr('tabindex', currentTabIndex);
	currentTabIndex++;
	jQuery('#contactPasswordConfirm').attr('tabindex', currentTabIndex);
	currentTabIndex++;
	jQuery('#registerSubmitButton').attr('tabindex', currentTabIndex);
	currentTabIndex++;

	jQuery('input, select').on('change', function () {
		var thisInput = jQuery(this);

		if (_.size(thisInput) === 0) {
			return;
		}

		if (_.size(thisInput.val()) > 0)
			thisInput.removeClass('registerErrorElement');

		if (thisInput.attr('type') == 'radio' && thisInput.parent('span').hasClass('radioBoolContainer')) {
			RadioBoolChanged(thisInput);
		}
		else if (thisInput.hasClass('formatCurrency')) {
			FormatCurrencyHelper(thisInput);
		}
	});

	jQuery('#contactCountry').on('change', function () {
		jQuery('#contactZip').val('');
		if (jQuery(this).val().toLowerCase() == 'ca') {
			jQuery('#contactStateUS').hide();
			jQuery('#contactStateCA').show();
			jQuery('#contactZip').mask('a9a 9a9', {
				placeholder: ""
			});
		}
		else {
			jQuery('#contactStateCA').hide();
			jQuery('#contactStateUS').show();
			jQuery('#contactZip').mask('99999', {
				placeholder: ""
			});
		}
	});
	jQuery('#contactCountry').val(regSettings.DefaultCountry);
	jQuery('#contactCountry').trigger('change');
	jQuery('#contactPhone, #contactCell, #contactFax').mask('(999) 999-9999', {
		placeholder: ""
	});

	if (regSettings.CreateLoginNote.length > 0)
		jQuery('.create-login-note').html(regSettings.CreateLoginNote);

	initGroupSelector();

	if (checkFieldVisible('workAreas')) {
		InitRegions();
	}
	jQuery('#registerSubmitButton').button().on('click', function () {
		jQuery('#registerSubmitButton').prop('disabled', true);
		RegisterUser();
	});
	if (!(PJQ.app.session.user != null && PJQ.app.session.user.id > 0) && !regSettings.IsPrivatePlanroom && ((pjqContactId == 0) || (regSettings.Contact != null && !regSettings.Contact.ContactUserId)) && window.location.href.toLowerCase().indexOf('updatecontact') == -1) {
		jQuery('#contactUsername').on('keyup change', function (e) {
			if (fbUserId == null) {
				if (jQuery('#contactUsername').val().length > 0) {
					PanteraScript.PanteraScriptService.CheckUsernameAvailability(pjqSessionId, jQuery('#contactUsername').val(), CheckUsernameAvailabilityC, onScriptError);
				}
				else {
					jQuery('#registerUsernameError').text("You have not entered a username");
					jQuery('#contactUsername').siblings('.successIcon').hide();
					jQuery('#contactUsername').siblings('.errorIcon').show();
				}
			}
		});

		jQuery('#contactPassword, #contactPasswordConfirm').on('keyup change', function (e) {
			if (fbUserId == null) {
				if (jQuery('#contactPasswordConfirm').val().length == 0 && jQuery('#contactPassword').val().length == 0) {
					jQuery('#contactPasswordConfirm').siblings('.errorIcon').show();
					jQuery('#contactPasswordConfirm').siblings('.successIcon').hide();
					jQuery('#contactPassword').siblings('.errorIcon').show();
					jQuery('#contactPassword').siblings('.successIcon').hide();
				}
				var passValidate = ValidatePassword(jQuery('#contactPassword').val());
				if (passValidate.isValid) {
					if (jQuery('#contactPasswordConfirm').val() == jQuery('#contactPassword').val() && jQuery('#contactPassword').val().length > 0) {
						jQuery('#registerPasswordError').empty();
						jQuery('#contactPasswordConfirm').siblings('.errorIcon').hide();
						jQuery('#contactPasswordConfirm').siblings('.successIcon').show();
						jQuery('#contactPassword').siblings('.errorIcon').hide();
						jQuery('#contactPassword').siblings('.successIcon').show();
						isPasswordError = false;
					}
					else {
						jQuery('#contactPasswordConfirm').siblings('.successIcon').hide();
						jQuery('#contactPasswordConfirm').siblings('.errorIcon').show();
						jQuery('#contactPassword').siblings('.errorIcon').hide();
						jQuery('#contactPassword').siblings('.successIcon').show();
						jQuery('#registerPasswordError').text("Passwords don't match!");
						isPasswordError = true;
					}
				}
				else {
					jQuery('#registerPasswordError').text(passValidate.validateError);
					jQuery('#contactPasswordConfirm').siblings('.errorIcon').show();
					jQuery('#contactPasswordConfirm').siblings('.successIcon').hide();
					jQuery('#contactPassword').siblings('.errorIcon').show();
					jQuery('#contactPassword').siblings('.successIcon').hide();
					isPasswordError = true;
				}
			}
		})
	}
	else if (regSettings.Username.length > 0) {
		jQuery('.facebookCol').hide();
		jQuery('#forgotPasswordReg').show();
	}

	jQuery('#registerBack').button().on('click', function () {
		LoginTransition();
	});

	if (regSettings.Contact != null) {
		jQuery('#companyName').val(regSettings.Contact.CompanyName);
		jQuery('#contactTitle').val(regSettings.Contact.ContactTitle);
		jQuery('#contactName').val(regSettings.Contact.ContactName);
		jQuery('#contactPhone').val(FormatPhoneHelper(regSettings.Contact.Phone));
		jQuery('#contactPhoneExt').val(regSettings.Contact.PhoneExtension);
		jQuery('#contactCell').val(FormatPhoneHelper(regSettings.Contact.Cell));
		jQuery('#contactFax').val(FormatPhoneHelper(regSettings.Contact.Fax));
		jQuery('#contactAddress1').val(regSettings.Contact.Address1);
		jQuery('#contactAddress2').val(regSettings.Contact.Address2);
		jQuery('#contactCity').val(regSettings.Contact.City);
		jQuery('#contactCountry').val(regSettings.Contact.Country);
		jQuery('#contactCountry').trigger('change');
		if (regSettings.Contact.Country.toLowerCase() == "us") {
			jQuery('#contactStateUS').val(regSettings.Contact.StateProvince);
		}
		else if (regSettings.Contact.Country.toLowerCase() == "ca") {
			jQuery('#contactStateCA').val(regSettings.Contact.StateProvince);
		}
		jQuery('#contactZip').val(regSettings.Contact.PostalCode);
		jQuery('#contactEmail').val(regSettings.Contact.Email);

		var unionSelections = [];
		var minoritySelections = [];

		if ((regSettings.Contact != null && regSettings.Contact.UserId == 39)) {

			if (regSettings.IsPrequalUnion)
				unionSelections.push('UNION');

			if (regSettings.IsPrequalNonUnion)
				unionSelections.push('NONUNION');

			this.$('.contactLaborStatus').find('option[VALUE="PREVWAGE"]').hide();

			if (regSettings.IsPrequalDBE)
				minoritySelections.push('DBE');
			if (regSettings.IsPrequalDVBE)
				minoritySelections.push('DVBE');
			if (regSettings.Contact.IsSDVBE)
				minoritySelections.push('SDVBE');
			if (regSettings.IsPrequalMBE)
				minoritySelections.push('MBE');
			if (regSettings.IsPrequalSBE)
				minoritySelections.push('SBE');
			if (regSettings.IsPrequalWBE)
				minoritySelections.push('WBE');
		}
		else if (regSettings.Contact != null) {
			if (regSettings.Contact.IsUnion)
				unionSelections.push('UNION');
			if (regSettings.Contact.IsNonUnion)
				unionSelections.push('NONUNION');
			if (regSettings.Contact.IsPrevailingWage)
				unionSelections.push('PREVWAGE');

			if (regSettings.Contact.IsDBE)
				minoritySelections.push('DBE');
			if (regSettings.Contact.IsDVBE)
				minoritySelections.push('DVBE');
			if (regSettings.Contact.IsSDVBE)
				minoritySelections.push('SDVBE');
			if (regSettings.Contact.IsMBE)
				minoritySelections.push('MBE');
			if (regSettings.Contact.IsSBE)
				minoritySelections.push('SBE');
			if (regSettings.Contact.IsWBE)
				minoritySelections.push('WBE');

		}

		if (!regSettings.IsPrivatePlanroom && regSettings.Username.length > 0 && window.location.href.toLowerCase().indexOf('userreg') != -1) {
			jQuery('#contactUsername').val(regSettings.Username).prop('disabled', true);
			jQuery('#contactPasswordConfirmRow').hide();
		}
	}

	if (regSettings.HasCompanyUploader) {
		window.companyUploader = new PJQ.views.files.FileUploaderGrid({
			el: $('.company-attachments-uploader')
		});

		$('.company-attachments-label').html(regSettings.CompanyUploaderLabel + (regSettings.CompanyUploaderRequired ? '<span class="requiredAst">*</span>' : ''));
		if (_.size(regSettings.CompanyUploaderNote) > 0) {
			$('.company-attachments-note').html(regSettings.CompanyUploaderNote);
			$('.company-attachments-note').removeClass('hidden');
		}

		$('.company-attachments').removeClass('hidden');
	}

	unionPicker = new PJQ.inputs.Selectpicker({
		el: this.$('.contactLaborStatus'),
		noneSelectedText: 'Labor Status',
		hideDisabled: false,
		isMultiple: true,
		onChange: _.bind(function (value) {
		}, this)
	});
	unionPicker.setValue(unionSelections);

	minorityPicker = new PJQ.inputs.Selectpicker({
		el: this.$('.contactMinorityStatus'),
		noneSelectedText: 'Minority Status',
		hideDisabled: false,
		isMultiple: true,
		exclusiveChoices: "NA",
		onChange: _.bind(function (value) {
		}, this)
	});
	minorityPicker.setValue(minoritySelections);

	if ((PJQ.app.session.user != null && PJQ.app.session.user.id > 0) || regSettings.IsPrivatePlanroom || (regSettings.Contact != null && regSettings.Contact.ContactUserId > 0 && window.location.href.toLowerCase().indexOf('userreg') == -1) || window.location.href.toLowerCase().indexOf('updatecontact') != -1) {
		jQuery('#loginInfoTable').hide();
	}
	if (typeof customRegistrationFunc === 'function')
		customRegistrationFunc();
}

let groupsTree = null;

window.contactGroupSelector = null;

function initGroupSelector() {
	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ALLOW_SUB_GROUP_EDIT)) {
		if (regSettings.ShouldUseOldGroupSelector) {
			if (regSettings.SubGroupsRestrictChoiceCount > 0) {
				jQuery('tr.groupsRow td div div').append('&nbsp;(Max ' + regSettings.SubGroupsRestrictChoiceCount.toString() + ')');
			}

			groupsTree = new dhtmlXTreeObject("groupsTree", "100%", "100%", "groupsTree");
			groupsTree.setListDelimeter('|');
			groupsTree.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxtree/imgs/');
			groupsTree.setStdImages('groupChild.png', 'groupParent.png', 'groupParent.png');
			groupsTree.setEscapingMode("utf8");
			groupsTree.enableSmartXMLParsing(true);
			groupsTree.loadXML("/DesktopModules/PJQRegistration/GetRegistrationGrid.aspx?sessionId=" + pjqSessionId + "&muid=" + pjqMasterUserId + "&gridId=GroupsTree", function () {
				regSettings.IsGroupsEnabled = false;
				if (groupsTree.getAllSubItems('groupsTree').length > 0) {
					regSettings.IsGroupsEnabled = true;
					var xmlFile = '/DesktopModules/PJQRegistration/GetPrequalContactCompanyGroups.aspx?sessionid=' + pjqSessionId + '&cc=' + pjqContactId.toString() + '&x=' + (new Date).getTime();
					if (pjqContactId > 0) {
						jQuery.ajax({
							type: "POST",
							url: xmlFile,
							dataType: "text",
							success: function (result) {
								GetPrequalContactCompanyGroupsC(result);
							},
							error: function (xhr, status, error) {
								showInfoDialog('Load Error', "An error occurred while loading data: " + error, 'ui-icon-alert');
							}
						});
					}
					else
						jQuery('.groupsRow').show();
				}
			});
			groupsTree.enableCheckBoxes(true, false);
			groupsTree.enableThreeStateCheckboxes(true);

			groupsTree.attachEvent("onCheck", function (id, state) {
				let saveGroups = [];
					if (regSettings.ShouldUseOldGroupSelector) {
						let selGroups = groupsTree.getAllChecked().split('|');
						for (let i = 0; i < selGroups.length; i++) {
							if (!(selGroups[i].indexOf('_1') > -1 || selGroups[i].indexOf('_2') > -1) && selGroups[i].length > 0)
								saveGroups.push(parseInt(selGroups[i]));
						}
					}
					else {
						saveGroups = _.map(contactGroupSelector.getGroupsData().selected, function (group) {
							return group.id;
						});
					}

					if (saveGroups.length > 0 && regSettings.SubGroupsRestrictChoiceCount > 0 && saveGroups.length === regSettings.SubGroupsRestrictChoiceCount) {
						DisableAllCheckboxes();
					}
					else{
						EnableAllCheckboxes();
					}

				jQuery('#groupsTreeContainer').removeClass('registerErrorElement');
				jQuery('#registerGroupsError').empty();
			});

			groupsTree.attachEvent("onXLE", function (id, state) {
				if (regSettings.IsDisableUnopenedParentGroups)
					DisableUnopenedGroupsCheckbox();
				else if (regSettings.IsDisableParentGroups || regSettings.SubGroupsRestrictChoiceCount > 0)
					DisableAllParentGroupsCheckbox();
			});

			groupsTree.attachEvent("onOpenEnd", function (id, state) {
				if (regSettings.IsDisableUnopenedParentGroups)
					DisableUnopenedGroupsCheckbox();
				else if (regSettings.IsDisableParentGroups || regSettings.SubGroupsRestrictChoiceCount > 0)
					DisableAllParentGroupsCheckbox();
			});
		}
		else {
			let selectedGroups = null;
			if (regSettings.ContactGroupList != null) {
				selectedGroups = new PJQ.collections.groups.Groups(PJQ.helpers.objectHelpers.convertObjectCamelcase(regSettings.ContactGroupList));
			}
			contactGroupSelector = new PJQ.views.groups.GroupSelector({
				el: $('.reg-group-selector'),
				selectedGroups: selectedGroups,
				isDisabledCollapsedParents: regSettings.IsDisableUnopenedParentGroups,
				isDisableParents: regSettings.IsDisableParentGroups,
				groupUserId: PJQ.app.session.get('masterUserId'),
				groupLevels: regSettings.GroupLevels,
				groupLabel: regSettings.GroupLabel
			});
			jQuery('.group-selector-row').show();
		}
	}
}

function GetPrequalContactCompanyGroupsC(response) {
	var cgResult = jQuery.parseJSON(response);
	jQuery('.groupsRow').show();
	for (var cg = 0; cg < cgResult.length; cg++) {
		groupsTree.setCheck(cgResult[cg].GroupId, 1);
		if (groupsTree.getParentId(cgResult[cg].GroupId).length > 0)
			groupsTree.openItem(groupsTree.getParentId(cgResult[cg].GroupId));
	}
}

function InitRegions() {
	window.regionsMapObj = new PJQ.views.workAreas.WorkAreaMap({
		el: $('#regionsOuterContainer'),
		contactId: pjqContactId,
		isInline: false,
		isEdit: true,
		isSync: false
	});

	let $regionsRow = $('.regionsRow')
	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PJQ_REGISTRATION_WORKAREAS_OPTIONAL)) {
		$regionsRow.find('.requiredAst').remove();
	}
	$regionsRow.show();
}

function RegisterUser() {
	//insert registration overlay while saving
	let isCompanyInfoError = false,
		isGroupsError = false,
		isGroupCountError = false,
		isRegionsError = false,
		isEmailError = false,
		isDirectoryLaborStatusError = false;

	let contactUsername = '',
		contactPassword = jQuery('#contactPassword').val();
	if (regSettings.Username.length > 0 && window.location.href.toLowerCase().indexOf('userreg') != -1 && window.location.href.toLowerCase().indexOf('updatecontact') == -1) {
		contactUsername = regSettings.Username;
		contactPassword = jQuery('#contactPassword').val();
		jQuery('#contactPassword').trigger('change');
	}
	else if (regSettings.Contact == null || regSettings.Contact.ContactUserId == null || regSettings.Contact.ContactUserId == 0 && window.location.href.toLowerCase().indexOf('updatecontact') == -1) {
		contactUsername = jQuery('#contactUsername').val();
		contactPassword = jQuery('#contactPassword').val();
		jQuery('#contactUsername').trigger('change');
		jQuery('#contactPassword').trigger('change');
	}
	else if (regSettings.IsPrivatePlanroom || ((pjqContactId > 0) && !(regSettings.Contact != null && regSettings.Contact.UserId == 39 && !regSettings.Contact.ContactUserId))) {
		contactUsername = '';
		contactPassword = '';
	}
	else if (fbUserId != null) {
		contactUsername = 'guid';
		contactPassword = 'guid';
	}

	jQuery('#registerForm').find('input, textarea, select').each(function () {
		var thisInput = jQuery(this);

		if (!thisInput.is(':visible'))
			return;

		let isThisCompanyInfoError = false;
		if (thisInput.is('input')) {
			if (thisInput.attr('id') === 'contactEmail' && checkFieldRequired('email')) {
				let emailValidation = PJQ.helpers.validators.validateEmail(thisInput.val(), !regSettings.IsForceEmailSingle);
				if (!emailValidation.success) {
					isThisCompanyInfoError = true;
					isEmailError = true;
				}
				else {
					isEmailError = false;
				}
			}
			else if (thisInput.attr('id') === 'contactCell' && checkFieldRequired('cell')) {
				if (FormatPhoneHelper(thisInput.val(), true).length !== 10) {
					isThisCompanyInfoError = true;
				}
				else {
					isThisCompanyInfoError = false;
				}
			}
			else if (thisInput.attr('type') == 'radio' && thisInput.parent('span').hasClass('radioBoolContainer') && thisInput.parent('span').attr('required') == 'required') {
				if (thisInput.parent('span').find('input:checked').length == 0) {
					isThisCompanyInfoError = true;
				}
			}
			else if (thisInput.attr('type') == 'checkbox' && thisInput.parent('div').parent('div').hasClass('multCheckboxContainer') && thisInput.parent('div').parent('div').attr('required') == 'required') {
				if (thisInput.parent('div').parent('div').find('input:checked').length == 0) {
					isThisCompanyInfoError = true;
				}
			}
			else if ((thisInput.attr('type') == 'number' || thisInput.attr('type') == 'text') && thisInput.prop('required')) {
				if (thisInput.hasClass('formatPhone') && FormatPhoneHelper(thisInput.val(), true).length != 10)
					isThisCompanyInfoError = true;
				else if (thisInput.val().length == 0)
					isThisCompanyInfoError = true;
			}
		}
		else if (thisInput.is('select')) {
			if (thisInput.prop('required') && thisInput.val() != null && thisInput.val().length == 0)
				isThisCompanyInfoError = true;
		}

		if (isThisCompanyInfoError && thisInput.attr('type') != 'radio' && thisInput.attr('type') != 'checkbox') {
			isCompanyInfoError = true;
			thisInput.addClass('registerErrorElement');
		}
		else if (isThisCompanyInfoError && thisInput.attr('type') == 'radio' && thisInput.parent('span').hasClass('radioBoolContainer')) {
			thisInput.parent('span').addClass('registerErrorElement');
			isCompanyInfoError = true;
		}
		else if (isThisCompanyInfoError && thisInput.attr('type') == 'checkbox' && thisInput.parent('div').parent('div').hasClass('multCheckboxContainer')) {
			thisInput.parent('div').parent('div').addClass('registerErrorElement');
			isCompanyInfoError = true;
		}
		else {
			thisInput.removeClass('registerErrorElement');
			thisInput.parent('div').parent('div').removeClass('registerErrorElement');
			thisInput.parent('div').removeClass('registerErrorElement');
			thisInput.parent('span').removeClass('registerErrorElement');
		}
	});

	if (regSettings.CompanyUploaderRequired && _.size(companyUploader.collection.models) === 0) {
		companyUploader.showError("You must upload at least 1 file", 0);
		isCompanyInfoError = true;
	}

	let saveGroups = [];
	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ALLOW_SUB_GROUP_EDIT)) {
		if (regSettings.ShouldUseOldGroupSelector) {
			let selGroups = groupsTree.getAllChecked().split('|');
			for (let i = 0; i < selGroups.length; i++) {
				if (!(selGroups[i].indexOf('_1') > -1 || selGroups[i].indexOf('_2') > -1) && selGroups[i].length > 0)
					saveGroups.push(parseInt(selGroups[i]));
			}
		}
		else {
			saveGroups = _.map(contactGroupSelector.getGroupsData().selected, function (group) {
				return group.id;
			});
		}

		if (_.size(saveGroups) === 0 && checkFieldRequired('groups')) {
			isGroupsError = true;
			jQuery('#groupsTreeContainer').addClass('registerErrorElement');
		}
		else if (saveGroups.length > 0 && regSettings.SubGroupsRestrictChoiceCount > 0 && saveGroups.length > regSettings.SubGroupsRestrictChoiceCount) {
			isGroupCountError = true;
			jQuery('#groupsTreeContainer').addClass('registerErrorElement');
		}
		else {
			jQuery('#groupsTreeContainer').removeClass('registerErrorElement');
		}
	}

	if (window.regionsMapObj && checkFieldRequired('workAreas')) {
		if (_.size(_.filter(window.regionsMapObj.collection.models, function (model) {
			return !model.get('isDeleted');
		})) === 0) {
			isRegionsError = true;
		}
	}

	jQuery('#registerMiscError').empty();
	if (checkFieldVisible('laborStatus') && checkFieldRequired('laborStatus')) {
		if (!unionPicker.getValue().length) {
			isDirectoryLaborStatusError = true;
			jQuery('#registerMiscError').append('Please indicate your Labor Status<br />');
		}
	}

	if (checkFieldVisible('classifications') && checkFieldRequired('classifications')) {
		if (!minorityPicker.getValue().length) {
			isDirectoryLaborStatusError = true;
			jQuery('#registerMiscError').append('Please indicate your Minority Status<br />');
		}
	}

	if (isCompanyInfoError) {
		jQuery('#registerCompanyInfoError').text('There are incomplete items in the company info section');
	}
	else {
		jQuery('#registerCompanyInfoError').empty();
	}
	if (isEmailError) {
		jQuery('#registerEmailError').text('Email address information is invalid');
	}
	else {
		jQuery('#registerEmailError').empty();
	}
	if (isGroupsError || isGroupCountError) {
		if (isGroupsError)
			jQuery('#registerGroupsError').text('You have not added trades yet');
		else
			jQuery('#registerGroupsError').text('You have added too many trades. (Max ' + regSettings.SubGroupsRestrictChoiceCount.toString() + ')');
	}
	else {
		jQuery('#registerGroupsError').empty();
	}
	if (isRegionsError) {
		jQuery('#registerRegionsError').text('You have not added regions yet');
	}
	else {
		jQuery('#registerRegionsError').empty();
	}

	if (!isCompanyInfoError && !isGroupsError && !isGroupCountError && !isRegionsError && !isUsernameError && !isPasswordError && !isEmailError && !isDirectoryLaborStatusError) {
		var contactCustomFieldsString = GetCustomFieldsString('contact');
		var contactCompanyCustomFieldsString = GetCustomFieldsString('company');
		var contactState = '';
		if (jQuery('#contactCountry').val().toLowerCase() == 'us') {
			contactState = jQuery('#contactStateUS').val();
		}
		else if (jQuery('#contactCountry').val().toLowerCase() == 'ca') {
			contactState = jQuery('#contactStateCA').val();
		}
		CreateOverlay(regSettings.CurrentMode);
		var isUpdater = (window.location.href.toLowerCase().indexOf('updatecontact') != -1);
		PanteraScript.PanteraScriptService.RegisterUser(pjqSessionId, pjqMasterUserId, pjqContactId, pjqProjectId, jQuery('#companyName').val(), jQuery('#contactTitle').val(), jQuery('#contactName').val(), jQuery('#contactPhone').val(), jQuery('#contactPhoneExt').val(), jQuery('#contactCell').val(), jQuery('#contactFax').val(), jQuery('#contactAddress1').val(), jQuery('#contactAddress2').val(), jQuery('#contactCity').val(), contactState, jQuery('#contactZip').val(), jQuery('#contactCountry').val(), jQuery('#contactEmail').val(), contactUsername, contactPassword, saveGroups.join(','), null, contactCustomFieldsString, contactCompanyCustomFieldsString, (_.indexOf(unionPicker.getValue(), 'UNION') != -1), (_.indexOf(unionPicker.getValue(), 'NONUNION') != -1), (_.indexOf(unionPicker.getValue(), 'PREVWAGE') != -1), (_.indexOf(minorityPicker.getValue(), 'DBE') != -1), (_.indexOf(minorityPicker.getValue(), 'DVBE') != -1), (_.indexOf(minorityPicker.getValue(), 'MBE') != -1), (_.indexOf(minorityPicker.getValue(), 'SBE') != -1), (_.indexOf(minorityPicker.getValue(), 'DVBE') != -1), (_.indexOf(minorityPicker.getValue(), 'WBE') != -1), isUpdater, RegisterUserC, onScriptError);
	}
	else {
		jQuery('#registerSubmitButton').prop('disabled', false);
	}
}

function RegisterUserC(response) {
	let regResult = jQuery.parseJSON(response);
	jQuery('#registerSubmitButton').prop('disabled', false);
	DestroyOverlay();
	if (regResult.Result || _.size(regResult.ResultNote) === 0) {
		if (window.regionsMapObj) {
			window.regionsMapObj.collection.options.contactId = regResult.ContactId;
			_.each(window.regionsMapObj.collection.models, function (model) {
				model.set('contactId', regResult.ContactId);
			});
			window.regionsMapObj.save(function () {
				if (window.companyUploader != null) {
					UploadAttachments(regResult);
				}
				else {
					RegisterUserSuccess(regResult);
				}
			});
		}
		else {
			if (window.companyUploader != null) {
				UploadAttachments(regResult);
			}
			else {
				RegisterUserSuccess(regResult);
			}
		}
	}
	else {
		jQuery('#registerMiscError').text(regResult.ResultNote);
	}
}

function UploadAttachments(regResult) {
	new PJQ.ajax.Request({
		endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'registration',
				value: regResult.ContactId
			},
			{
				endpoint: 'attachments'
			}
		]),
		data: {
			attachments: window.companyUploader.collection.toJSON()
		},
		isApi2: true
	}).post().done(_.bind(function () {
		RegisterUserSuccess(regResult);
	}, this));
}

function RegisterUserSuccess(regResult) {

	if (pjqMasterUserId == 39 && PJQ.app.session.contact)
		PJQ.app.session.contact.set('isApprovalRequired', true);

	let routePreference = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.REGISTRATION_REDIRECT);
	if(routePreference != null){
		window.location.href = window.location.origin + routePreference
	}
	else if (pjqMasterUserId == 39) {

		window.location.href = 'https://app.panteratools.com/';
		/*
        new PJQ.views.BaseModal({
            header: "Registration Completed",
            body: 'Thanks for registering with Pantera Tools.   You will begin receiving email notifications for Project Opportunities after your information has been reviewed.<br /><br />We will now redirect you to the login page.',
            isShowCancelButton: false,
            onOk: _.bind(function () {
                window.location.href = 'https://app.panteratools.com/';
            }, this)
        });
        */
	}
	else if (!regSettings.IsHideAppDialog && window.location.href.indexOf('updatecontact') != -1) {
		initAppDialog(regResult.RedirectURL);
	}
	else if (regSettings.IsPrivatePlanroom) {
		InitPrivateContactRegisteredNotify();
	}
	else if (regResult.RedirectURL.length > 0)
		window.location.href = regResult.RedirectURL;
	else if (pjqContactId > 0) {
		InitContactUpdatedNotify();
	}
	else {
		window.location.href = window.location.origin;
	}

}

function RegisterSocialMediaUserC(response) {
	window.location.reload();
}

var isUsernameError = false;

function CheckUsernameAvailabilityC(response) {
	var userResult = jQuery.parseJSON(response);
	//Make sure this response matches current uname entry -
	//this is method is called onkeyup for the username, so sometimes responses come out of order from when they were sent
	if (userResult.Username == jQuery('#contactUsername').val()) {
		if (userResult.Result) {
			jQuery('#contactUsername').siblings('.errorIcon').hide();
			jQuery('#contactUsername').siblings('.successIcon').show();
			jQuery('#registerUserButton').button('enable');
			jQuery('#registerUsernameError').empty();
			isUsernameError = false;
		}
		else {
			jQuery('#contactUsername').siblings('.errorIcon').show();
			jQuery('#contactUsername').siblings('.successIcon').hide();
			jQuery('#registerUserButton').button('disable');
			jQuery('#registerUsernameError').text("Username already exists");
			isUsernameError = true;
		}
	}
}

var isPasswordError = false;

function ValidatePassword(password) {
	var validate = {
		isValid: true,
		validateError: ''
	};
	var passCharValidate = new RegExp(/^[\w!@#%&/(){}[\]=?+*^~\-.:,;]{1,32}$/);
	if (password.length < 7) {
		validate.isValid = false;
		validate.validateError = 'Password must be 7 characters';
	}
	else if (!passCharValidate.test(password)) {
		validate.isValid = false;
		validate.validateError = 'Password can only contain numbers and letters';
	}
	return validate;
}

function ValidateDate(dateString) {
	// First check for the pattern
	if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
		return false;

	// Parse the date parts to integers
	var parts = dateString.split("/");
	var day = parseInt(parts[1], 10);
	var month = parseInt(parts[0], 10);
	var year = parseInt(parts[2], 10);

	// Check the ranges of month and year
	if (year < 1000 || year > 3000 || month == 0 || month > 12)
		return false;

	var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	// Adjust for leap years
	if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
		monthLength[1] = 29;

	// Check the range of the day
	return day > 0 && day <= monthLength[month - 1];
}

/* Facebook Functions */
function InitFacebookAPI(apiKey) {
	FB.init({
		appId: apiKey,
		xfbml: true,
		version: 'v2.2'
	});
}

function CheckLoginState() {
	FB.getLoginStatus(function (response) {
		if (response.status == 'connected') {
			FB.api('/me?fields=token_for_business', function (apiResponse) {
				FacebookLoginHandler(apiResponse);
			});
		}
		else {
			FB.login(function (loginResponse) {
				if (loginResponse.status == 'connected') {
					FB.api('/me?fields=token_for_business', function (apiResponse) {
						FacebookLoginHandler(apiResponse);
					});
				}
			}, {
				scope: 'public_profile,email'
			});
		}
	});
}

var fbUserId = null;
var fbBusinessToken = null;

function FacebookLoginHandler(apiResponse) {
	fbUserId = apiResponse.id;
	fbBusinessToken = apiResponse.token_for_business;
	if (regSettings.CurrentMode == 'register') {
		PanteraScript.PanteraScriptService.GetSocialMediaUserSocialMediaStatusForSession(pjqSessionId, fbUserId, CheckFacebookUserRegStatus, onScriptError);
	}
	else {
		CreateOverlay(regSettings.CurrentMode);
		PanteraScript.PanteraScriptService.AuthFacebookUserForSession(pjqSessionId, fbUserId, fbBusinessToken, AuthFacebookUserC, onScriptError);
	}
}

function CheckFacebookUserRegStatus(response) {
	var regResult = jQuery.parseJSON(response);
	if (!regResult.IsFacebookRegistered) {
		jQuery('#loginInfoTable').hide();
		jQuery('#registerFacebookSuccessContainer').show();
		isUsernameError = false;
		isPasswordError = false;
	}
	else {
		SocialMediaUserExists();
	}
}

var isFacebookLoginSuccess = false;

function SocialMediaUserExists() {
	jQuery('#fbUserExistsDialog').dialog({
		title: "User Exists",
		modal: true,
		width: 350,
		closeOnEscape: false,
		resizable: false,
		dialogClass: 'fbUserExistsDialog',
		buttons: [{
			text: "Yes",
			click: function () {
				PanteraScript.PanteraScriptService.AuthFacebookUserForSession(pjqSessionId, fbUserId, fbBusinessToken, AuthFacebookUserC, onScriptError);
				isFacebookLoginSuccess = true;
				jQuery(this).dialog('close');
			}
		}, {
			text: "No",
			click: function () {
				isFacebookLoginSuccess = false;
				jQuery(this).dialog('close');
			}
		}],
		close: function () {
			if (isFacebookLoginSuccess)
				CreateOverlay('login');
			else {
				fbUserId = null;
				fbBusinessToken = null;
			}
			isFacebookLoginSuccess = false;
		}
	})
}

function AuthFacebookUserC(response) {
	var authResponse = jQuery.parseJSON(response);
	if (authResponse.Status) {
		window.location.href = authResponse.RedirectURL;
	}
	else {
		DestroyOverlay();
		jQuery('#loginError').text('No user found linked with this facebook login');
	}
}

var currentTabIndex = 15;

function CreateRegistrationCustomFields(customFields, customFieldType) {
	for (var cf = 0; cf < customFields.length; cf++) {
		var thisCustomField = null;
		var thisFieldIdInt = 0;
		var thisFieldId = "";
		var thisFieldChoices = null;
		var thisFieldValue = "";
		var thisChoiceIdList = "";
		if (customFieldType == 'contact') {
			thisCustomField = customFields[cf].ContactCustomField;
			thisFieldIdInt = thisCustomField.ContactCustomFieldId;
			thisFieldId = 'cf_' + thisCustomField.ContactCustomFieldId;
			thisFieldChoices = customFields[cf].ContactCustomFieldChoices;

			if (_.size(customFields[cf].ContactCustomFieldValue) > 0) {
				thisFieldValue = customFields[cf].ContactCustomFieldValue;
			}
			else if (_.size(thisCustomField.DefaultValue) > 0) {
				thisFieldValue = thisCustomField.DefaultValue;
			}
			else {
				thisFieldValue = '';
			}

			if (_.size(customFields[cf].ChoiceIdList) > 0) {
				thisChoiceIdList = customFields[cf].ChoiceIdList.split(',');
			}
			else if (_.size(thisCustomField.DefaultValue) > 0) {
				thisChoiceIdList = thisCustomField.DefaultValue.split(',');
			}
			else {
				thisChoiceIdList = [];
			}
		}
		else {
			thisCustomField = customFields[cf].ContactCompanyCustomField;
			thisFieldIdInt = thisCustomField.ContactCompanyCustomFieldId;
			thisFieldId = 'cmf_' + thisCustomField.ContactCompanyCustomFieldId;
			thisFieldChoices = customFields[cf].ContactCompanyCustomFieldChoices;

			if (_.size(customFields[cf].ContactCompanyCustomFieldValue) > 0) {
				thisFieldValue = customFields[cf].ContactCompanyCustomFieldValue;
			}
			else if (_.size(thisCustomField.DefaultValue) > 0) {
				thisFieldValue = thisCustomField.DefaultValue;
			}
			else {
				thisFieldValue = '';
			}

			if (_.size(customFields[cf].ChoiceIdList) > 0) {
				thisChoiceIdList = customFields[cf].ChoiceIdList.split(',');
			}
			else if (_.size(thisCustomField.DefaultValue) > 0) {
				thisChoiceIdList = thisCustomField.DefaultValue.split(',');
			}
			else {
				thisChoiceIdList = [];
			}
		}
		jQuery('#companyInfoTable').append('<tr id="cfContainer_' + thisFieldIdInt + '"><td></td><td></td></tr>');
		var thisCustomFieldContainer = jQuery('#cfContainer_' + thisFieldIdInt);
		thisCustomFieldContainer.find('td:first-child').append('<label for="' + thisFieldId + '" class="registerInputLabel">' + thisCustomField.FieldName + '</label>');
		var requiredString = "";
		if (thisCustomField.IsRequiredInRSVP) {
			thisCustomFieldContainer.find('td:first-child').find('label').append('<span class="requiredAst">*</span>');
			requiredString = "required";
		}
		var thisFieldInput = "";
		switch (thisCustomField.FieldType.toLowerCase()) {
			case 'text':
				thisFieldInput = '<input tabindex="' + currentTabIndex + '" type="text" class="registerInput" id="' + thisFieldId + '"' + requiredString + ' />';
				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
				jQuery('#' + thisFieldId).val(thisFieldValue);
				break;
			case 'money':
				thisFieldInput = '<input tabindex="' + currentTabIndex + '" type="text" class="registerInput formatCurrency" id="' + thisFieldId + '"' + requiredString + ' />';
				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
				jQuery('#' + thisFieldId).val(FormatCurrencyValueHelper(thisFieldValue));
				break;
			case 'int':
				var minMaxValueString = 'max="' + thisCustomField.NumericMaxValue + '" min="' + thisCustomField.NumericMinValue + '"';
				thisFieldInput = '<input tabindex="' + currentTabIndex + '" type="number" class="registerInput" ' + minMaxValueString + ' id="' + thisFieldId + '"' + requiredString + ' />';
				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
				jQuery('#' + thisFieldId).on('change', function () {
					if (parseInt(jQuery(this).val()) > parseInt(jQuery(this).attr('max')))
						jQuery(this).val(jQuery(this).attr('max'));
					else if (parseInt(jQuery(this).val()) < parseInt(jQuery(this).attr('min')))
						jQuery(this).val(jQuery(this).attr('min'));
				});
				jQuery('#' + thisFieldId).val(thisFieldValue);
				break;
			case 'date':
				thisFieldInput = '<input tabindex="' + currentTabIndex + '" type="text" class="registerInput dateInput" id="' + thisFieldId + '"' + requiredString + ' />';
				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
				jQuery('#' + thisFieldId).on('change', function () {
					if (!ValidateDate(jQuery(this).val()))
						jQuery(this).val('');
				});
				if (ValidateDate(thisFieldValue))
					jQuery('#' + thisFieldId).val(thisFieldValue);
				break;
			case 'textarea':
				thisFieldInput = '<textarea tabindex="' + currentTabIndex + '" class="registerInput" id="' + thisFieldId + '"' + requiredString + ' />';
				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
				jQuery('#' + thisFieldId).val(thisFieldValue);
				break;
			case 'choice':
				thisFieldInput = '<div class="multCheckboxContainer registerInput" id="' + thisFieldId + '" ' + requiredString + '></div>';
				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
				var customFieldIds = [];
				var customFieldNames = thisFieldValue.split(',');
				if (!thisCustomField.IsChoiceListMultipleChoice) {
					thisFieldInput = '<select tabindex="' + currentTabIndex + '" class="registerInput" id="' + thisFieldId + '" ' + requiredString + '></select>';
					thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);
					jQuery('#' + thisFieldId).append('<option value="">Select...</option>');
					jQuery('#' + thisFieldId).val(thisFieldValue);
				}
				for (var cfc = 0; cfc < thisFieldChoices.length; cfc++) {
					var thisChoiceId = 0;
					if (customFieldType == 'contact') {
						thisChoiceId = thisFieldChoices[cfc].ContactCustomFieldChoiceId;
						for (var i = 0; i < thisChoiceIdList.length; i++) {
							if (thisChoiceId == thisChoiceIdList[i]) {
								if (thisCustomField.IsChoiceListMultipleChoice) {
									customFieldIds.push(thisFieldChoices[cfc].ContactCustomFieldChoiceId);
								}
								else {
									thisFieldValue = thisFieldChoices[cfc].ContactCustomFieldChoiceId;
								}
							}
						}
					}
					else if (customFieldType == 'company') {
						thisChoiceId = thisFieldChoices[cfc].ContactCompanyCustomFieldChoiceId;
						for (var i = 0; i < thisChoiceIdList.length; i++) {
							if (thisChoiceId == thisChoiceIdList[i]) {
								if (thisCustomField.IsChoiceListMultipleChoice) {
									customFieldIds.push(thisFieldChoices[cfc].ContactCompanyCustomFieldChoiceId);
								}
								else {
									thisFieldValue = thisFieldChoices[cfc].ContactCompanyCustomFieldChoiceId;
								}
							}
						}
					}
					if (thisCustomField.IsChoiceListMultipleChoice) {
						jQuery('#' + thisFieldId).append('<div><input tabindex="' + currentTabIndex + '" class="verticalRadio" type="checkbox" value="' + thisChoiceId + '" id="cfc_' + thisChoiceId + '"><span class="radioLabel">' + thisFieldChoices[cfc].ChoiceName + '</span></div>');
					}
					else {
						jQuery('#' + thisFieldId).append('<option value="' + thisChoiceId + '">' + thisFieldChoices[cfc].ChoiceName + '</option>');
					}
				}
				if (thisCustomField.IsChoiceListMultipleChoice) {
					ChangeMultipleCheckbox(jQuery('#' + thisFieldId), customFieldIds);
				}
				else {
					jQuery('#' + thisFieldId).val(thisFieldValue);
				}

				break;
			case 'bool':
				thisFieldInput = '<span id="' + thisFieldId + '" class="radioBoolContainer registerInput" ' + requiredString + '><input tabindex="' + currentTabIndex + '" type="radio" class="choiceTrue"><span class="radioLabel">Yes</span><input type="radio" class="choiceFalse"><span class="radioLabel">No</span></span>';

				thisCustomFieldContainer.find('td:nth-child(2)').html(thisFieldInput);

				if (thisFieldValue.length > 0)
					ChangeRadioBool(jQuery('#' + thisFieldId), (thisFieldValue == 'true' ? true : false));
				break;
		}
		currentTabIndex++;
		jQuery("input.dateInput").mask('99/99/9999', {
			placeholder: " "
		});
		jQuery('input.dateInput').datepicker({
			showOn: "button",
			numberOfMonths: 3,
			showButtonPanel: true,
			buttonImage: "/i/calendar.png",
			buttonImageOnly: true
		});
		jQuery('input.dateInput').each(function () {
			jQuery(this).appendTo(jQuery(this).parent('td'));
		});
	}
}

function GetCustomFieldsString(customFieldType) {
	var customFieldsString = '';
	var customFieldIdPrefix = '';
	if (customFieldType == 'company') {
		customFieldIdPrefix = 'cmf_';
	}
	else if (customFieldType == 'contact') {
		customFieldIdPrefix = 'cf_';
	}
	else {
		return '';
	}
	jQuery('#registerForm').find('input[id*="' + customFieldIdPrefix + '"], select[id*="' + customFieldIdPrefix + '"], textarea[id*="' + customFieldIdPrefix + '"], div.multCheckboxContainer[id*="' + customFieldIdPrefix + '"], span.radioBoolContainer[id*="' + customFieldIdPrefix + '"]').each(function () {
		var field = jQuery(this);
		var fieldId = field.attr('id').replace(customFieldIdPrefix, '');
		var fieldValue = '';
		var thisCustomFieldString = '';
		if (field.hasClass('radioBoolContainer')) {
			fieldValue = GetRadioBoolValue(field);
		}
		else if (field.hasClass('multCheckboxContainer')) {
			fieldValue = GetMultipleCheckboxValue(field);
		}
		else if (field.hasClass('formatPhone')) {
			fieldValue = FormatPhoneHelper(field.val());
		}
		else {
			fieldValue = field.val();
		}

		if (fieldValue.length == 0) {
			return;
		}
		else {
			thisCustomFieldString = fieldId + '{|}' + fieldValue;
		}

		if (customFieldsString.length == 0) {
			customFieldsString = thisCustomFieldString;
		}
		else {
			customFieldsString += ('||||' + thisCustomFieldString);
		}
	});
	return customFieldsString;
}

function FormatCurrencyHelper(field) {
	var parsedValue = '0';
	if (!(/[a-z]/i).test(field.val())) {
		var parsedValue = field.val().replace("$", "");
		parsedValue = parsedValue.replace(/,/g, "");
	}
	var formattedValue = parsedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	if (formattedValue.trim().length != 0) {
		field.val('$' + formattedValue);
	}
	else {
		field.val('');
	}
}

function FormatCurrencyValueHelper(value) {
	var parsedValue = '0';
	if (!(/[a-z]/i).test(value)) {
		parsedValue = value.replace("$", "");
		parsedValue = parsedValue.replace(',', "");
	}
	var formattedValue = parsedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	if (formattedValue.trim().length != 0) {
		formattedValue = '$' + formattedValue;
	}
	else {
		formattedValue = '';
	}
	return formattedValue;
}

function FormatPhoneHelper(value, isUnformat) {
	if (typeof value != 'undefined') {
		var phoneFormatted;
		value = value.replace('(', '');
		value = value.replace(')', '');
		value = value.replace(/-/g, '');
		value = value.replace(' ', '');
		value = value.replace('/', '');
		if (isUnformat) {
			return value;
		}
		if (value.toLowerCase() == 'na')
			phoneFormatted = 'N/A';
		else if (value.length != 0) {
			phoneFormatted = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10);
		}
		else {
			phoneFormatted == '';
		}
		return phoneFormatted;
	}
	else {
		return '';
	}
}

function GetMultipleCheckboxValue(field) {
	var responseValue = '';
	field.closest('div.multCheckboxContainer').find('input[type="checkbox"]').each(function () {
		if (jQuery(this).prop('checked') == true) {
			var radioAddInputValue = "";
			if (responseValue.length == 0)
				responseValue = jQuery(this).val();
			else
				responseValue = responseValue + ',' + jQuery(this).val();
		}
	});
	return responseValue;
}

function ChangeMultipleCheckbox(field, valueArray) {
	for (var v = 0; v < valueArray.length; v++) {
		field.find('input[value="' + valueArray[v] + '"]').prop('checked', true);
		field.find('input[value="' + valueArray[v] + '"]').trigger('change');
	}
}

function GetRadioBoolValue(field) {
	var result = '';
	if (field.find('.choiceTrue').prop('checked') == true) {
		result = 'true';
	}
	else if (field.find('.choiceFalse').prop('checked') == true) {
		result = 'false';
	}
	return result;
}

function RadioBoolChanged(obj) {
	obj.siblings('input[type="radio"]').prop('checked', false);
	var radioResult = false;
	if (obj.hasClass('choiceTrue')) {
		radioResult = true;
	}
}

function ChangeRadioBool(field, value) {
	if (value) {
		field.find('.choiceTrue').prop('checked', true);
		field.find('.choiceFalse').prop('checked', false);
		field.find('.choiceTrue').trigger('change');
	}
	else if (!value) {
		field.find('.choiceFalse').prop('checked', true);
		field.find('.choiceTrue').prop('checked', false);
		field.find('.choiceFalse').trigger('change');
	}
	RadioBoolChanged(field);
}

function CreateOverlay(type) {

}

function DestroyOverlay() {
	jQuery('#loginLoadingContainer').hide();
	jQuery('#updateLoadingContainer').hide();
	jQuery('#registerLoadingContainer').hide();
	jQuery('#updateRegionsMapContainer').hide();

}

function onScriptError(response) {
	//do nothing
}

function DisableUnopenedGroupsCheckbox() {
	var childrenGroupFirstArr = groupsTree.getSubItems('groupsTree').split('|');
	for (var i = 0; i < childrenGroupFirstArr.length; i++) {
		var thisParentGroup = groupsTree.getParentId(parseInt(childrenGroupFirstArr[i].substr(0, childrenGroupFirstArr[i].indexOf('_'))));

		var openState = groupsTree.getOpenState(thisParentGroup);
		if (openState == -1)
			groupsTree.disableCheckbox(thisParentGroup, true);
		else if (openState = 1)
			groupsTree.disableCheckbox(thisParentGroup, false);
	}
}

function DisableAllParentGroupsCheckbox() {
	var childrenGroupFirstArr = groupsTree.getSubItems('groupsTree').split('|');
	for (var i = 0; i < childrenGroupFirstArr.length; i++) {
		var thisParentGroup = groupsTree.getParentId(parseInt(childrenGroupFirstArr[i].substr(0, childrenGroupFirstArr[i].indexOf('_'))));
		groupsTree.disableCheckbox(thisParentGroup, true);
	}
}
let disabledCheckBoxes = null;
function DisableAllCheckboxes() {
	var idArray = groupsTree.getAllUnchecked().split('|');
	disabledCheckBoxes = idArray;
	for (var i = 0; i < idArray.length; i++) {
		groupsTree.disableCheckbox(parseInt(idArray[i]), true);
	}
}

function EnableAllCheckboxes() {
	if(disabledCheckBoxes != null) {
		for (var i = 0; i < disabledCheckBoxes.length; i++) {
			groupsTree.disableCheckbox(parseInt(disabledCheckBoxes[i]), false);
		}
		disabledCheckBoxes = null;
	}
}

function InitContactUpdatedNotify() {
	jQuery('#registerForm').hide();
	jQuery('#contactUpdatedNotify').show()
}

function InitPrivateContactRegisteredNotify() {
	jQuery('#registerForm').hide();
	jQuery('#privateContactRegisteredNotify').show()
}

function redirectToNetworkInfo() {
	window.location.href = 'http://network.panteratools.com/pantera-network/?' + pjqContactId;
}

function initAppDialog(redirectURL) {
	if (regSettings.IsHideAppDialog)
		return;

	var isAndroid = false;
	var device = "";
	if (navigator.userAgent.match(/android/i) != null) {
		device = "android";
	}
	else if (navigator.userAgent.match(/iPhone/i) != null || navigator.userAgent.match(/iPod/i) != null || navigator.userAgent.match(/iPad/i) != null) {
		device = "ios";
	}
	else {
		device = "pc";
	}
	if (device.length > 0) {
		jQuery("#appDialog").dialog({
			modal: true,
			title: "Pantera Mobile App",
			create: function () {
				var storeURL = "";
				if (device === "android") {
					jQuery("#appLogo").attr("src", "/assets/images/androidAppLogo.png");
					storeURL = 'https://play.google.com/store/apps/details?id=com.pantera&hl=en';
				}
				else if (device === "ios") {
					jQuery("#appLogo").attr("src", "/assets/images/iosAppLogo.png");
					storeURL = 'https://itunes.apple.com/us/app/pantera-mobile/id1208253224?ls=1&mt=8';
				}
				else if (device == "pc") {
					jQuery("#appLogo").attr("src", "/assets/images/iosAppLogo.png");
					storeURL = "http://app.panteratools.com/Default.aspx?tabid=13997";
				}

				if (regSettings.AdminCompanyName.length > 0)
					jQuery("#appDownloadTitle").text(regSettings.AdminCompanyName + " encourages you to download the FREE Pantera Mobile App!");

				jQuery('#downloadApp').button().off().on('click', function () {
					window.open(storeURL);
					jQuery('#appDialog').dialog('close');
				});
				jQuery('#cancelDownloadApp').button().off().on('click', function () {
					jQuery('#androidAppDialog').dialog('close');
					jQuery('#appDialog').dialog('close');
				});
			},
			close: function () {
				InitContactUpdatedNotify();
			}
		});
	}
}

function checkFieldVisible(fieldName) {
	if (coreFieldSettings == null) {
		let prefs = PJQ.app.session.preferences;
		let result;
		switch (fieldName) {
			case 'sector':
				result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
				break;
			case 'laborStatus':
				result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
				if (result && prefs.hasPref(PJQ.constants.preferenceTypes.CAN_EDIT_UNION_STATUS_SUB)) {
					result = prefs.getPref(PJQ.constants.preferenceTypes.CAN_EDIT_UNION_STATUS_SUB);
				}
				break;
			case 'classifications':
				result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false &&
					prefs.getPref(PJQ.constants.preferenceTypes.CAN_EDIT_MINORITY_CLASS_SUB);
				break;
			case 'workAreas':
				result = regSettings.IsRegionsMapEnabled;
				break;
			default:
				result = true;
		}
		return result;
	}
	else {
		let fieldSettings = coreFieldSettings.findWhere({fieldName: fieldName});
		if (fieldSettings != null) {
			return fieldSettings.get('isVisibleContact');
		}
	}
	return true;
}

function checkFieldRequired(fieldName) {
	if (!checkFieldVisible(fieldName)) {
		return false;
	}

	if (coreFieldSettings == null) {
		let prefs = PJQ.app.session.preferences;
		switch (fieldName) {
			case 'contactName':
				return true;
			case 'companyName':
				return true;
			case 'address1':
				return true;
			case 'address2':
				return false;
			case 'city':
				return true;
			case 'state':
				return true;
			case 'country':
				return true;
			case 'zip':
				return true;
			case 'phone':
				return true;
			case 'cell':
				return regSettings.IsCellRequired;
			case 'email':
				return true;
			case 'laborStatus':
				return !regSettings.IsUnionStatusNotRequired;
			case 'classifications':
				return !regSettings.IsMinorityStatusNotRequired;
			case 'groups':
				return prefs.hasPref(PJQ.constants.preferenceTypes.ALLOW_SUB_GROUP_EDIT_REQUIRED);
			case 'workAreas':
				return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PJQ_REGISTRATION_WORKAREAS_OPTIONAL)
		}
	}
	else {
		let fieldSettings = coreFieldSettings.findWhere({fieldName: fieldName});
		if (fieldSettings != null) {
			return fieldSettings.get('isRequiredContact');
		}
	}
	return false;
}
